/**
 * Chat Unread Count Hook
 */

import { useQuery } from "@tanstack/react-query"
import { apiClient } from "@/lib/api-client"

async function getChatUnreadCount(): Promise<number> {
  const response = await apiClient.get<{
    success: boolean
    data: { unreadCount: number }
    message: string
  }>("/api/conversations/unread-count")
  return response.data.data.unreadCount
}

export function useChatUnreadCount() {
  // No refetchOnWindowFocus override: the count is pushed in real time via
  // NotificationRealtimeContext (the chat:unread_count_updated event calls
  // setQueryData(["chat-unread-count"], count)), and that context also resyncs on
  // realtime reconnect -- so a refetch on every tab focus was redundant load
  // (issue #528). Inherits the global default (refetchOnWindowFocus: false).
  return useQuery({
    queryKey: ["chat-unread-count"],
    queryFn: getChatUnreadCount,
  })
}
